import { createFileRoute } from "@tanstack/react-router";
import { Box } from "@televet/kibble-ui/chakra";

export const Route = createFileRoute("/token-login")({
  component: TokenLogin,
});

function TokenLogin() {
  return <Box>Logging in...</Box>;
}
